import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Layout from "./components/Layout";
import HomePage from "./pages/HomePage";
import Locations from "./pages/Locations";
import Story from "./pages/Story";
import Convenience from "./pages/Convenience";
import Community from "./pages/Community";
import PartnerWithUS from "./pages/PartnerWithUS";
import FuelCards from "./pages/FuelCards";
import Fuels from "./pages/Fuels";
import Error404 from "./pages/404Error";
import ContactUs from "./pages/ContactUs";
import Suppliers from "./pages/Suppliers";
import ChristmasGiveaway from "./pages/ChristmasGiveaway";
import Budgetboost from "./pages/Budgetboost";
import Employment from "./pages/Employment";
import Comp from "./pages/Comp";
import { useEffect } from "react";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        index: true,
        element: <HomePage />,
      },
      {
        path: "locations",
        element: <Locations />,
        exact:true,
      },
      {
        path: "our-story",
        element: <Story />,
        exact:true,
      },
      {
        path: "convenience",
        element: <Convenience />,
        exact:true,
      },
      {
        path: "community",
        element: <Community />,
        exact:true,
      },
      {
        path: "gascorp",
        element: <PartnerWithUS />,
        exact:true,
      },
      {
        path: "fuel-1-card",
        element: <FuelCards />,
        exact:true,
      },
      {
        path: "fuels",
        element: <Fuels />,
        exact:true,
      },
      {
        path: "contact-us",
        element: <ContactUs />,
        exact:true,
      },
      {
        path: "suppliers",
        element: <Suppliers />,
        exact:true,
      },
      {
        path : "budget-boost",
        element : <Budgetboost />,
        exact:true,
      },
      {
        path : "giveaway",
        element:<ChristmasGiveaway/>,
        exact:true,
      },
      {
        path:"employment",
        element:<Employment/>,
        exact:true,
      },
      {
        path:"comp",
        element:<Comp/>,
        exact:true,
      },
      {
        path : "*",
        element : <Error404 />
      },
    ],
  },
]);

function App() {
  useEffect(()=>{
    localStorage.setItem("insta_access_token","IGQWROQVFodzEyaU9JNExzTjNDb3pCS1RBUjJuSmIyZA1paOVlwcXlJWGVpMW56aTlKWDBNXzN3bkd4bFBMX25WZAHBobXN6TERIOW1Vc1B2azQwaURpVndoTGZAEY0poU1Q5VjRsV19UaHdOQQZDZD");
    localStorage.setItem("token_expiry_time","5183999")
  },[])
  return (
    <>
      <RouterProvider router={router} />
    </>
  );
}

export default App;
